import client from './client';

export const getIngredients = (params) =>
  client.get('/ingredients', { params }).then((r) => r.data);

export const getIngredient = (sku) =>
  client.get(`/ingredients/${sku}`).then((r) => r.data);

export const createIngredient = (data) =>
  client.post('/ingredients', data).then((r) => r.data);

export const getLowStockIngredients = () =>
  client.get('/ingredients/low-stock').then((r) => r.data);

export const updateIngredientStock = (sku, data) =>
  client.patch(`/ingredients/${sku}/stock`, data).then((r) => r.data);

export const searchIngredients = (q, limit) =>
  client
    .get('/ingredients/search', { params: { q, limit } })
    .then((r) => r.data);

export const getIngredientByBarcode = (barcode) =>
  client.get(`/ingredients/barcode/${barcode}`).then((r) => r.data);
